import Vue, { DirectiveFunction } from 'vue'
import { DirectiveOptions } from 'vue'
import { fromEvent, concat } from 'rxjs'
import { map, takeUntil, concatMap, reduce, scan, filter } from 'rxjs/operators'

const resize: DirectiveFunction = (el, bindings) => {
  const { value } = bindings
  let axis = 'x'
  let cb: (...args) => void = () => ({})
  let min = 40
  if (typeof value === 'string') {
    axis = value
  } else {
    axis = value.axis || axis
    cb = value.cb || cb
    min = value.min || min
  }

  const parent = el.parentElement as HTMLElement
  el.className = `resize-directive-${axis} ${el.className}`
  const elIndex = Array.prototype.findIndex.call(parent.children, item => {
    return item.className.includes(`resize-directive-${axis}`)
  })
  const leftBro = parent.children[elIndex - 1] as HTMLElement
  const rightBro = parent.children[elIndex + 1] as HTMLElement

  const mouseDown = fromEvent(el, 'mousedown')
  const mouseMove = fromEvent(parent, 'mousemove')
  const mouseUp = concat(fromEvent(parent, 'mouseup'), fromEvent(el, 'mouseup'), fromEvent(window, 'mouseup'))

  if (axis === 'y') {
    let leftHeight: number, rightHeight: number
    mouseDown
      .pipe(
        concatMap(() =>
          mouseMove.pipe(
            map((ev: MouseEvent) => {
              document.querySelector('body').style.userSelect = 'none'
              if (typeof leftHeight === 'undefined' && typeof rightHeight === 'undefined') {
                leftHeight = leftBro.getBoundingClientRect().height
                rightHeight = rightBro.getBoundingClientRect().height
              }
              return { height: ev.clientY - 56, offset: 0, lh: leftHeight, rh: rightHeight }
            }),
            scan((acc, curr) => ({ height: acc.height, offset: curr.height - acc.height, lh: curr.lh, rh: curr.rh })),
            filter(size => size.lh + size.offset >= min && size.rh - size.offset >= min),
            takeUntil(
              mouseUp.pipe(
                map(() => {
                  document.querySelector('body').style.userSelect = 'text'
                  leftHeight = undefined
                  rightHeight = undefined
                  return
                })
              )
            )
          )
        )
      )
      .subscribe(obj => {
        leftBro.style.height = obj.lh + obj.offset + 'px'
        rightBro.style.height = obj.rh - obj.offset + 'px'
        cb(obj)
      })
  }

  if (axis === 'x') {
    let leftWidth, rightWidth
    mouseDown
      .pipe(
        concatMap(() =>
          mouseMove.pipe(
            map((ev: MouseEvent) => {
              document.querySelector('body').style.userSelect = 'none'
              if (typeof leftWidth === 'undefined' && typeof rightWidth === 'undefined') {
                leftWidth = leftBro.getBoundingClientRect().width
                rightWidth = rightBro.getBoundingClientRect().width
              }
              return {
                width: ev.clientX - 56,
                offset: 0,
                lw: leftWidth,
                rw: rightWidth,
              }
            }),
            scan((acc, curr) => ({ width: acc.width, offset: curr.width - acc.width, lw: curr.lw, rw: curr.rw })),
            filter(size => size.lw + size.offset >= min && size.rw - size.offset >= min),
            takeUntil(
              mouseUp.pipe(
                map(() => {
                  document.querySelector('body').style.userSelect = 'text'
                  leftWidth = undefined
                  rightWidth = undefined
                  return
                })
              )
            )
          )
        )
      )
      .subscribe(obj => {
        leftBro.style.width = obj.lw + obj.offset + 'px'
        rightBro.style.width = obj.rw - obj.offset + 'px'
        cb(obj)
      })
  }
}

Vue.directive('resize', {
  inserted: resize,
} as DirectiveOptions)
